import React from 'react'

const NoResultIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={173} height={166} fill="none">
      <path
        fill="#D2D9EE"
        d="M172.059 87.828c-.397-16.135-11.739-26.678-19.95-28.871-12.004-3.208-14.805 3.495-4.704 8.954 9.927 5.364 19.114 21.66 20.706 26.643 1.051 3.281 4.138 1.237 3.948-6.726Z"
      />
      <path
        fill="#D2D9EE"
        d="M124.448 136.653c-33.54 15.155-72.335.604-93.962-25.526-35.488-42.874-5.255-77.705 24.26-84.391 51.206-11.594 56.319 26.235 75.344 36.444 41.724 22.392 47.714 49.355-5.644 73.467l.002.006Z"
      />
      <path
        fill="#F0C4BA"
        d="m30.394 144.246-.377-4.497 3.83-.006.097 4.489c.414.536.76 1.052 1.042 1.546-1.5.737-4.012.737-5.52-.695l.925-.837h.003Z"
      />
      <path
        fill="#6684C2"
        d="M33.662 150.527h-7.077c-1.574-.109-1.077-1.959 0-2.835l2.884-2.609c2.066.084 4.07.427 5.519.695 1.583 2.754 1.161 4.757-1.323 4.749h-.003Z"
      />
      <path
        fill="#F0C4BA"
        d="m38.13 142.949.495-4.168 3.6.323-.544 3.535 2.753 1.309c-1.175 2.006-4.804 2.564-7.258 1.537.251-.711.586-1.546.954-2.539v.003Z"
      />
      <path
        fill="#6684C2"
        d="M50.947 149.243H38.092c-1.697-.705-1.639-1.716-.916-3.755 3.093-.084 5.637-.619 7.258-1.537l6.513 3.099c1.72.556 1.896 2.082 0 2.193Z"
      />
      <path
        fill="#B8C1BF"
        d="m27.671 80.579 18.23-.31 2.163 14.824c-6.588-1.88-13.98-1.33-21.627 0l1.237-14.514h-.003Z"
      />
      <path
        fill="#1D2342"
        d="M38.83 80.102c-2.526-8.929 7.05-14.78 8.44-9.197 6.97 27.95 4.011 36.757-4.515 71.678l-5.24-.951c5.062-29.854 6.075-44.703 1.316-61.53ZM37.147 78.517c-.092-8.06-10.075-9.48-10.357-4.44-1.507 26.97 1.05 41.548 2.697 69.776l5.25-.318c.258-24.949 2.672-41.793 2.413-65.018h-.003Z"
      />
      <path
        fill="#CF8C5F"
        d="M65.626 40.162c-2.226-.761-4.387 4.611-1.2 6.385l16.11 6.473c1.847.668 3.01-1.495 1.176-2.884-5.199-3.947-10.775-8.15-16.088-9.971l.002-.003Z"
      />
      <path
        fill="#DBDCDD"
        d="M45.194 33.247c-4.964-1.405-9.003 6.378-1.026 8.327l20.503 5.06c6.067.775 5.158-5.059 1.526-6.414l-21.003-6.973Z"
      />
      <path
        fill="#CF8C5F"
        d="M79.549 52.591c.33.182 1.048 1.103 1.186 1.5.418 1.203.04 1.213 1.812 2.966.605.6.992 1.417 1.373 1.098.572-.477.4-1.11-.194-1.786-.353-.401-.671-.772-.714-.926-.06-.21.52-.043.84.22.837.689 2.164 1.882 2.742 2.725.905 1.313 1.722.483 1.159-.491-.576-.995-1.09-1.533-2.018-2.3.085-.068.175-.081.262-.03 1.052.623 2.109 1.617 2.899 2.617.573.728 1.58.226.913-.679-.815-1.103-1.787-2.09-2.846-2.772.004-.027.007-.054.013-.083.866.377 1.534.774 2.3 1.32.982.698 1.44-.2.545-1.014-.877-.802-1.866-1.32-3.098-1.899.004-.112.062-.158.218-.101.457.168 1.355.463 2.22.795.703.27 1.059-.484.403-.889-.929-.574-2.332-1.231-3.797-1.802-1.734-.675-2.458-.329-4.458-1.257l-1.755 2.791-.005-.003Z"
      />
      <path
        fill="#C67B47"
        d="m76.972 51.586 2.447-3.182c-.614-.462-1.23-.919-1.853-1.372l-1.269 4.285.673.272.002-.003Z"
      />
      <path
        fill="#DBDCDD"
        d="m64.154 46.655 12.373 4.97 2.427-4.417C74.641 44.005 69.32 41 65.543 40.022c-2.276-.59-4.58 4.858-1.39 6.63v.003Z"
      />
      <path
        fill="#AEB7B5"
        d="M40.763 28.755c-2.44-.84-5.781-1.38-8.185-.823 0 0 .095 6.618 5.435 6.462 6.876-.198 2.75-5.639 2.75-5.639Z"
      />
      <path
        fill="#CF8C5F"
        d="m33.646 32.5-.025-13.34 2.34-.005a8.179 8.179 0 0 0-.757 3.501c.008 3.759 2.42 6.808 5.388 6.803h.01l.244 3.027-7.197.014h-.003Z"
      />
      <path
        fill="#C67B47"
        d="M34.777 21.995c.232-1.259.7-1.817 1.184-2.84l3.81-.009.83 10.31h-.012c-3.029.516-6.488-3.773-5.812-7.464v.003Z"
      />
      <path
        fill="#CF8C5F"
        d="M35.636 8.633c3.42.028 5.494.706 6.789 1.81 1.329 1.136 1.837 2.724 2.119 4.537.156.996.243 2.06.366 3.15.175 1.585.385 3.067.496 4.384.02.217.034.43.048.639.042.686.044 1.32-.008 1.886-.213 2.243-1.335 3.485-4.727 3.038-2.727-.36-4.927-2.486-6.485-5.351-.69-1.267-1.25-2.679-1.677-4.146-1.611-5.547-1.597-9.986 3.079-9.947Z"
      />
      <path
        fill="#C67B47"
        d="M36.496 15.711c-2.677 1.622-2.35-4.09-2.35-4.09l8.282-1.177c1.329 1.135 1.837 2.723 2.119 4.536-1.552-1.049-4.268-1.556-8.048.731h-.003Z"
      />
      <path
        fill="#2F1D18"
        d="M43.058 17.277c-.179.028-.282.34-.226.697.055.357.242.625.424.597.181-.028.28-.34.223-.697-.056-.357-.243-.625-.421-.597ZM38.283 18.005c-.237.036-.388.357-.332.714.056.357.293.62.53.583.238-.036.389-.357.333-.714-.056-.357-.293-.62-.53-.583Z"
      />
      <path
        fill="#3E0B27"
        d="M41.384 10.407c-1.092 1.68-6.691-1.099-7.09 1.323l-.031-.008c-1.491.3-2.072 1.724-1.712 3.58-.407 1.366-1.2 2.675-3.618 2.985a10.984 10.984 0 0 1-1.113-1.948c-2.329-5.268 1.06-8.119 2.791-8.923 2.962-1.375 6.644-2.419 11.225-.96 2.61.83 3.127 2.235 2.881 3.377-1.295-.55-2.77-.288-3.333.58v-.006Z"
      />
      <path
        fill="#071128"
        d="M43.458 11.593s-.793-.764-1.734-.6c.489 1.948-3.57 2.015-7.431.737.4-2.422 6 .354 7.09-1.322.564-.868 2.041-1.13 3.334-.58-.182.847-.785 1.55-1.262 1.765h.003ZM32.55 15.299c.188.97.629 2.059 1.338 3.172.318.497-.433 2.12-.243 2.58.715 1.739.011 2.891-.584 1.591-.438-.96-2.487-2.059-4.125-4.36 2.417-.31 3.21-1.616 3.617-2.986l-.002.003Z"
      />
      <path
        fill="#CF8C5F"
        d="M32.222 17.804c-.826.41-1.052 1.632-.508 2.726.545 1.094 1.656 1.649 2.485 1.239.826-.41 1.052-1.632.508-2.726s-1.658-1.65-2.485-1.239Z"
      />
      <path
        fill="#AD6736"
        d="M33.585 19.115c.042-.284-.358-.591-.854-.502-.676.123-.684 1.144-.252 1.766.112-.667 1.064-.97 1.106-1.264Z"
      />
      <path fill="#5A0B0A" d="M43.789 23.37c-.575-.46-3.632.084-3.895.659.774 1.088 4.322 1.205 3.895-.659Z" />
      <path
        fill="#071128"
        d="M36.008 17.129c-.12-.045.43-2.416 2.063-2.654 1.047-.153 1.07.595.64.678-1.852.355-2.583 2.02-2.703 1.976ZM44.152 15.047c.056-.044-.676-1.2-1.583-1.024-.583.112-.455.514-.212.478 1.044-.154 1.74.591 1.795.546Z"
      />
      <path fill="#fff" d="M43.663 22.921c-.062.489-.296.876-.975 1.01-1.172.235-2.113-.125-2.649-.588l3.623-.422Z" />
      <path fill="#A71D43" d="M40.195 24.905c.232-.424.704-.756 1.284-.845.843-.129 1.62.295 1.812.96l-3.096-.115Z" />
      <path
        fill="#CF8C5F"
        d="M39.117 24.274c.1.896 1.427 1.485 2.96 1.314 1.532-.172 2.693-1.037 2.593-1.933-.1-.896-1.427-1.484-2.96-1.314-1.532.173-2.693 1.038-2.593 1.933Zm.777-.245c.697-.042 3.316-1.119 3.894-.659.427 1.864-3.121 1.747-3.894.659Z"
      />
      <path
        fill="#071128"
        d="M34.537 18.557c1.571.88.544 4.638 3.933 6.992-1.304-3.152 1.778-3.638 3.663-3.878 1.99-.254 2.816-.039 3.271.843.02.217.034.43.048.639-.28-.441-.868-.726-1.24-.603-.918.304-1.566.63-1.937.047-.04.586-1.49.656-2.599.623-1.485-.045-1.463 2.33.095 2.873 2.593.904 3.06-.892 3.06-.892s2.007 1.392 2.612-.162c-.212 2.243-1.334 3.485-4.726 3.038-2.727-.36-4.927-2.486-6.485-5.351.9-.023 1.444-2.023.305-4.169Z"
      />
      <path
        fill="#C67B47"
        d="M41.512 21.286c-.254-.26-.628-.32-.835-.134a.405.405 0 0 0-.078.103c-.332-1.113-.567-3.981-.17-4.48.566-.718 3.316 3.002 3.009 4.388-.27 1.228-1.468 1.15-1.963 1.008a.33.33 0 0 0 .12-.073c.207-.187.168-.55-.086-.81l.003-.002Z"
      />
      <path
        fill="#AD6736"
        d="M40.663 21.442a1.835 1.835 0 0 1-.061-.187.386.386 0 0 1 .078-.103c.206-.187.58-.128.834.134.255.26.294.622.087.81a.444.444 0 0 1-.12.072c-.009 0-.017-.006-.025-.006a1.178 1.178 0 0 1-.787-.72h-.006Z"
      />
      <path
        fill="#CF8C5F"
        d="M40.583 37.184c-1.999-.226-7.911-4.581-6.99-6.863a25.376 25.376 0 0 1 3.9-.235c1.6.02 3.123.193 4.528.51.162 1.2.016 5.715-1.438 6.588Z"
      />
      <path
        fill="#54ACD3"
        d="M23.846 39.042c.396-2.41 1.359-4.3 2.83-5.708 1.678-1.61 4.015-2.592 6.918-3.014.608 2.286 4.413 4.975 6.41 5.201 1.454-.873 2.18-3.724 2.018-4.924 2.194.5 4.1 1.356 5.563 2.561 2.102 1.733 3.283 4.18 3.08 7.296-.076 1.122-.258 2.966-.5 5.184-.916 8.379-2.686 22.073-2.686 22.073.045.229.078.452.115.675-6.421 1.415-13.607 1.018-20.17-.661.056-.084.11-.168.168-.251-1.111-5.734-5.313-18.876-3.746-28.432Z"
      />
      <path
        fill="#071B45"
        d="M26.096 70.15c.349-.827.795-1.639 1.326-2.425 6.563 1.677 13.748 2.076 20.169.661.145.918.223 1.791.24 2.617.131 7.427-4.802 11.191-10.957 11.216-10.91.042-13.24-6.252-10.778-12.067v-.003Z"
      />
      <path
        fill="#EDEEEF"
        d="M41.367 30.301c5.71 1.083 9.821 4.5 9.458 9.997-.075 1.121-.257 2.966-.5 5.184-.915 8.379-2.529 22.075-2.529 22.075 2.608 9.314 4.093 25.388 4.093 25.388s-3.054 3.987-8.964 4.598c-4.813-18.903-.916-38.8.464-51.556.544-5.045.85-14.57-2.022-15.686Z"
      />
      <path
        fill="#fff"
        d="M43.02 52.893c.513-2.087 1.962-9.35 3.556-13.226l-2.18-1.822 1.873-1.696-3.646-5.957-1.86-1.44c1.564 3.268 2.67 14.038 2.256 24.138v.003Z"
      />
      <path
        fill="#000"
        d="m32.793 28.56 12.224 23.242s.321.25.321 1.481c0 1.066 1.106 15.159-3.096 38.191-.943 5.179-1.501-4.029-1.501-4.029l-1.463-34.33-6.482-24.555h-.003Z"
        opacity={0.1}
      />
      <path
        fill="#EDEEEF"
        d="M25.9 67.95c1.504-5.644-3.167-15.797-3.758-28.051-.257-5.293 5.466-9.065 11.356-9.757-1.142 3.96 10.61 22.371 10.61 22.371.768 14.751-.306 27.198-5.228 45.024-11.264-.047-17.685-3.674-17.685-3.674 0-9.208 2.083-16.094 4.701-25.912h.003Z"
      />
      <path
        fill="#fff"
        d="M44.107 52.516c-1.58-1.616-6.532-7.363-9.591-9.43l.569-2.944-2.635-.762-2.18-8.995 2.305-2.458 11.532 24.586v.003Z"
      />
      <path
        fill="#DBDCDD"
        d="m29.306 42.396-3.573 18.566c-.974-5.6-3.199-12.86-3.595-21.063-.092-1.914 6.4-1.021 7.143 1.468l.023 1.029h.003Z"
      />
      <path
        fill="#D3D3D3"
        d="M42.811 55.093c.286-.04.458-.492.386-1.01-.073-.517-.363-.904-.649-.864-.285.04-.458.492-.385 1.01.072.517.363.904.648.864ZM43.035 65.695c.29-.004.52-.431.512-.953-.007-.523-.248-.943-.538-.94-.29.005-.519.432-.512.954.008.522.248.942.538.939ZM42.402 76.525c.087-.515-.073-.972-.357-1.02-.285-.048-.586.331-.673.846-.087.515.073.972.358 1.02.284.047.585-.331.672-.846Z"
      />
      <path
        fill="#8C400C"
        d="M125.138 16.44c-.656.57-1.96 2.4-1.695 4.266.201 1.429 1.203 2.659 2.493 3.306 1.29.648 9.654-6.448 12.864-6.972 3.995.926-1.17 4.86-.969 8.437.263 4.688 3.805 6.501 7.641 6.057-2.139-1.696-2.63-4.221-.391-5.784 3.341-2.326 4.835-6.046 3.71-8.755-1.538-3.708-5.745-4.057-9.877-1.359-1.493.974-13.776.801-13.776.801v.003Z"
      />
      <path
        fill="#B8C1BF"
        d="m139.63 77.552-20.228.268-1.976 14.885c7.255-2.087 15.468-1.772 23.991-.686l-1.787-14.47v.003Z"
      />
      <path
        fill="#DBDCDD"
        d="M127.681 32.966c2.414-.91 5.259-1.476 7.676-.988 0 0 .576 6.546-4.768 6.546-6.878 0-2.908-5.558-2.908-5.558Z"
      />
      <path
        fill="#F0C4BA"
        d="M109.619 42.03c2.087-.88 4.517 4.143 1.57 6.052l-15.051 7.27c-1.73.763-2.986-1.238-1.318-2.692 4.736-4.132 9.813-8.535 14.799-10.63Z"
      />
      <path
        fill="#DBDCDD"
        d="M128.792 34.056c4.677-1.674 9.066 5.537 1.532 7.93l-19.361 6.2c-5.776 1.141-5.286-4.523-1.887-6.06l19.719-8.072-.003.002Z"
      />
      <path
        fill="#F0C4BA"
        d="M97.062 54.88c-.306.193-.932 1.126-1.04 1.516-.321 1.184.04 1.166-1.547 2.967-.542.614-.862 1.425-1.248 1.144-.58-.422-.454-1.04.071-1.73.312-.41.596-.787.627-.938.045-.207-.5-.005-.789.266-.76.716-1.955 1.95-2.456 2.795-.782 1.321-1.622.577-1.143-.398.486-.991.946-1.542 1.786-2.341-.086-.061-.174-.067-.253-.013-.97.667-1.921 1.692-2.614 2.705-.504.736-1.503.32-.92-.594.709-1.114 1.576-2.124 2.55-2.85a.874.874 0 0 1-.015-.08c-.807.422-1.423.844-2.123 1.418-.898.738-1.397-.096-.591-.939.79-.827 1.707-1.39 2.852-2.026-.01-.108-.068-.147-.216-.083-.427.192-1.271.533-2.08.91-.657.305-1.05-.395-.445-.827.855-.61 2.158-1.335 3.531-1.978 1.622-.76 2.34-.475 4.2-1.497l1.87 2.567-.007.005Z"
      />
      <path
        fill="#EBAB9C"
        d="m99.472 53.745-2.56-2.898c.56-.481 1.124-.962 1.691-1.438l1.499 4.033-.628.305-.002-.002Z"
      />
      <path
        fill="#DBDCDD"
        d="m111.463 48.17-11.559 5.587-2.623-4.086c3.933-3.358 8.849-6.59 12.412-7.779 2.149-.716 4.715 4.368 1.77 6.278Z"
      />
      <path
        fill="#F0C4BA"
        d="M131.424 23.276a6.94 6.94 0 0 1 1.862 3.945c.41 3.343-1.619 6.228-4.536 6.442-.106.006-.215.003-.324.006l-.02 3.016 7.08-.51-.947-13.122-3.115.223Z"
      />
      <path
        fill="#EBAB9C"
        d="M133.282 27.227a6.923 6.923 0 0 0-1.862-3.946l-2.934.212-.064 10.181c.109 0 .212 0 .324-.005 2.917-.212 4.952-3.1 4.536-6.442Z"
      />
      <path
        fill="#F0C4BA"
        d="M128.137 18.923c-2.454-.934-3.403 1.604-3.894 2.612a18.33 18.33 0 0 0-.067 1.01c.192 4.174-.98 8.565 3.83 8.755 2.914.114 6.931-2.327 7.889-7.148 1.022-5.145 2.604-8.784-2.152-9.774a12.545 12.545 0 0 0-1.508-.223c.092.781-.938 5.973-4.098 4.77v-.002Z"
      />
      <path
        fill="#EBAB9D"
        d="M124.24 21.535c.492-1.008 1.644-2.363 4.154-1.593 4.559 1.395 3.931-5 3.841-5.787-3.953-.36-7.428 1.322-7.995 7.383v-.003Z"
      />
      <path
        fill="#2F1D19"
        d="M126.549 22.054c.176.039.256.348.187.694-.073.346-.274.606-.45.567-.176-.04-.257-.349-.187-.7.073-.34.274-.6.45-.561ZM131.205 23.022c.231.047.36.368.29.72-.073.346-.321.594-.553.546-.232-.047-.36-.368-.29-.72.075-.35.326-.594.553-.546Z"
      />
      <path
        fill="#8C400C"
        d="M132.875 22.282c.117-.041-.025-1.961-1.477-2.061-.932-.065-1.069.552-.689.594 1.636.187 2.052 1.512 2.169 1.465l-.003.002ZM125.628 20.675c-.051-.042.614-1.049 1.412-.881.511.106.397.463.179.424-.919-.151-1.541.5-1.591.457Z"
      />
      <path
        fill="#F0C4BA"
        d="m137.712 143.527.497-6.225-3.704.1-.232 6.214c-.383.53-.698 1.032-.961 1.521 1.343-.285 3.175-.656 5.092-.807l-.695-.8.003-.003Z"
      />
      <path
        fill="#6684C2"
        d="m134.726 149.682 5.907-.168c1.518-.15.675-1.914-.078-2.74l-2.144-2.449c-1.918.15-3.755.516-5.092.806-1.452 2.709-.997 4.632 1.407 4.554v-.003Z"
      />
      <path
        fill="#F0C4BA"
        d="m130.197 142.486-1.275-6.169-3.152.714.996 5.564-2.077 1.289c1.589.669 3.839 1.024 6.502 1.024-.265-.678-.606-1.476-.991-2.422h-.003Z"
      />
      <path
        fill="#6684C2"
        d="m120.466 148.85 9.943-.284c1.619-.731 1.536-1.702.779-3.658-2.663 0-4.919-.349-6.502-1.024l-4.589 2.854c-1.027.569-1.468 2.059.369 2.112Z"
      />
      <path
        fill="#F0C4BA"
        d="M128.414 40.767c1.921-.15 5.592-4.448 7.426-6.685-1.125-.168-2.365-.276-3.727-.349-1.653-.092-3.104.114-4.377.53-.137 1.102-.617 5.67.678 6.504Z"
      />
      <path
        fill="#54ACD3"
        d="M118.815 45.426c-.5 1.568-.24 3.546 1.873 4.707-.173 7.042 1.845 11.222 2.61 16.286-1.164 1.183-2.024 2.38-2.632 3.55 5.937 1.629 12.679 1.604 18.952.356-.916-1.412-2.13-2.698-3.451-3.953.467-2.057 1.904-4.755 3.384-7.843.966-2.015 2.479-5.293 3.489-8.228.98-2.852 1.421-5.832 1.042-8.697-.645-4.95-3.292-6.786-8.238-7.514-1.834 2.238-4.699 3.195-6.619 3.351-1.296-.834-1.619-2.073-1.488-3.17-5.622 1.834-7.856 7.824-8.919 11.158l-.003-.003Z"
      />
      <path
        fill="#1D2342"
        d="M140.716 72.49a10.832 10.832 0 0 0-1.1-2.167c-6.27 1.25-13.009 1.277-18.952-.358a10.636 10.636 0 0 0-.69 1.635c-2.188 6.77 4.003 12.514 11.105 12.11 6.329-.36 10.248-3.764 10.187-8.287a8.865 8.865 0 0 0-.553-2.933h.003Z"
      />
      <path
        fill="#1D2342"
        d="M129.057 82.331c2.56-7.868-8.441-12.742-9.469-9.749-8.341 24.266-3.182 35.468 6.044 66.162l5.117-.429c-2.761-18.379-7.981-36.682-1.692-55.984Z"
      />
      <path
        fill="#1D2342"
        d="M130.033 80.554c-.547-7.179 9.712-12.776 11.205-6.15 4.791 21.295-1.245 45.175-2.599 65.214l-5.145-.137c-.885-22.268-1.881-38.222-3.461-58.93v.003Z"
      />
      <path
        fill="#581211"
        d="M130.813 27.79c-.045 1.119-1.15 1.984-2.462 1.928-1.312-.056-2.34-1.007-2.295-2.126.045-1.119.458-1.604 1.776-1.548 1.317.055 3.031.63 2.981 1.749v-.003Z"
      />
      <path
        fill="#A71D43"
        d="M128.773 27.899c.946.036 1.367.951.865 1.002-.502.05-.508.689-1.454.652-.947-.036-1.215.486-1.181-.3.033-.785.829-1.39 1.77-1.351v-.003Z"
      />
      <path
        fill="#fff"
        d="M127.832 26.043c1.058-.175 2.259.073 2.329.77.069.698-1.326.98-2.376.966-.888-.009-1.15.053-1.22-.642-.075-.697.528-.968 1.27-1.094h-.003Z"
      />
      <path
        fill="#F0C4BA"
        d="M128.487 25.703c-1.73-.075-3.176.829-3.224 2.009-.05 1.186 1.315 2.198 3.046 2.274 1.73.075 3.177-.829 3.224-2.009.05-1.186-1.315-2.204-3.046-2.274Zm-2.04 1.992c.564-1.038 3.07.24 4.036-.21-1.289 1.689-4.19 1.32-4.036.21Z"
      />
      <path
        fill="#B2540F"
        d="M133.315 16.713s2.035.901 1.98 4.236c.351 3.055 3.732 5.809 5.767 2.893.148-.234.413-.776.871-2.391 1.53-5.413-3.185-8.822-6.736-8.117-2.527-3.515-7.423-2.12-10.65-.03-.419.273-.801.56-1.125.856.329 2.788 7.632 3.563 9.893 2.553Z"
      />
      <path
        fill="#8C400C"
        d="M135.293 20.949c-.014.73-.12 1.576-.377 2.558-.148.561.117 4.375.112 4.872 1.035.91 2.345-.21 2.814-.611.89-.76 2.372-2.029 3.221-3.926-1.672 1.836-4.843-.072-5.767-2.893h-.003ZM122.527 17.082c1.117 1.95 8.043 2.296 10.787-.369-2.261 1.01-9.564.235-9.894-2.553-.999.916-1.46 1.928-.893 2.922Z"
      />
      <path
        fill="#EFC3BA"
        d="M136.02 23.742c.745.421.935 1.5.419 2.41-.514.907-1.539 1.298-2.284.876-.745-.42-.935-1.5-.419-2.41.514-.907 1.539-1.298 2.284-.876Z"
      />
      <path
        fill="#B58180"
        d="M134.724 24.777c-.023-.282.385-.567.868-.447.659.157.611 1.161.153 1.753-.075-.667-.994-1.016-1.021-1.306Z"
      />
      <path
        fill="#EDEEEF"
        d="M127.07 34.33c-4.745 1.624-5.435 4.146-7.76 8.496-1.047 1.962-2.884 5.324 1.055 7.969-.424 4.425 1.89 8.22-.363 16.283-2.632 9.42-5.072 25.245-5.072 25.245s3.45 3.445 10.038 3.574c1.614-20.734 3.364-27.129.852-47.466-.547-4.42.396-11.486 1.253-14.104l-.003.003Z"
      />
      <path
        fill="#fff"
        d="M126.779 53.094c-1.158-1.898-3.246-7.355-3.986-10.714l1.929-1.58-1.63-1.503 3.249-5.193 1.34-1.135c-1.399 2.851-1.99 11.057-.904 20.127l.002-.002Z"
      />
      <path fill="#EBAB9D" d="M127.352 23.058c.022-.042.047-.078.069-.114-.022.036-.042.078-.069.114Z" />
      <path
        fill="#EBAB9D"
        d="M127.053 25.85c.352.336.966.378 1.449.244-.042-.025-.092-.048-.126-.09-.195-.223-.139-.63.126-.912.265-.279.637-.32.832-.1.033.036.05.083.064.128.335-1.155.263-3.67-.187-3.795-.265-.075-.673.201-1.08.648-.24.287-.48.614-.704.962l-.069.115c-.006.005-.003.01-.009.016-.583 1.019-.893 2.213-.296 2.782v.003Z"
      />
      <path
        fill="#B58180"
        d="M128.5 25.1c-.265.28-.321.69-.126.913.034.042.084.064.126.09h.014c.346-.099.645-.336.815-.768.025-.059.042-.129.067-.198-.019-.042-.033-.092-.064-.129-.195-.229-.567-.184-.832.095V25.1Z"
      />
      <path
        fill="#B2540F"
        d="M147.561 23.354c1.518-2.065 2.018-4.459 1.231-6.359-1.279-3.077-4.394-3.84-7.78-2.466 4.332 1.476-.19 12.82 6.546 8.822l.003.003Z"
      />
      <path
        fill="#000"
        d="m134.429 34.12-10.447 18.748s-.312.92-.469 1.844c-.156.923-2.967 12.293 2.061 34.528 1.474 6.514 1.529-.567 1.529-.567l1.248-33.038 6.075-21.511.003-.003Z"
        opacity={0.1}
      />
      <path
        fill="#EDEEEF"
        d="M139.327 67.354c-2.686-7.095 5.664-14.23 4.782-25.79-.355-4.633-3.255-7.63-9.221-7.717.969 3.483-9.904 17.843-10.303 19.86-3.202 16.178.46 30.508 3.844 42.494 10.485-.025 17.422-3.382 17.422-3.382-.988-8.312-3.096-16.411-6.524-25.465Z"
      />
      <path
        fill="#fff"
        d="M124.589 53.707c1.01-1.612 9.435-7.059 11.602-9.327l-1.061-2.254 2.066-1.133-.134-7.335-1.77-1.7-10.706 21.75h.003Z"
      />
      <path
        fill="#DBDCDD"
        d="m137.176 45.242 2.978 13.172c1.391-3.724 3.417-7.857 3.911-12.868l-1.27-4.048c-1.407-4.958-4.215.937-5.619 3.744Z"
      />
      <path
        fill="#F0C4BA"
        d="M150.007 64.059c-.93 2.16-6.368.148-5.539-3.404l6.022-16.267c.743-1.813 3.129-1.222 2.928 1.069-.566 6.498-1.192 13.448-3.411 18.602Z"
      />
      <path
        fill="#EDEEEF"
        d="M143.585 38.635c-1.781-4.835-7.192 4.459-6.566 6.292l7.18 17.315c2.939 5.357 7.129 1.192 6.091-2.539l-6.705-21.068Z"
      />
      <path
        fill="#F0C4BA"
        d="M150.288 45.396c.156-.625.312-1.248.081-1.992-.374-1.217-.559-1.08.131-3.471.234-.818.173-1.722.661-1.627.732.14.891.776.704 1.655-.112.524-.207 1.001-.17 1.157.05.212.474-.217.622-.6.397-1.01.966-2.698 1.061-3.716.148-1.587 1.265-1.261 1.251-.137-.017 1.147-.204 1.87-.634 2.991.109.02.193-.014.243-.1.611-1.058 1.049-2.441 1.248-3.7.145-.915 1.267-.968 1.127.148-.17 1.362-.533 2.695-1.125 3.806l.051.067c.569-.754.96-1.426 1.362-2.271.516-1.091 1.354-.53.971.616-.382 1.147-.982 2.062-1.775 3.17.059.097.131.109.24-.02.316-.37.955-1.066 1.549-1.777.481-.578 1.162-.095.785.58-.531.955-1.429 2.213-2.432 3.424-1.183 1.434-2.386.946-2.987 3.044l-2.967-1.247h.003Z"
      />
      <path fill="#EBAB9C" d="m149.159 47.99 4.006.33c-.072.764-.148 1.529-.229 2.293l-4.028-1.942.251-.68Z" />
      <path
        fill="#EDEEEF"
        d="m144.201 60.786 4.625-12.494 4.908 1.172c-.522 5.343-1.87 11.3-3.682 14.748-1.092 2.081-6.68.123-5.851-3.429v.003Z"
      />
      <path
        fill="#D3D3D3"
        d="M126.128 55.115c.08-.497-.067-.935-.329-.977-.262-.042-.539.327-.619.825-.08.497.067.935.329.977.262.042.539-.327.619-.825ZM125.012 64.243c.022-.503-.175-.92-.44-.932-.265-.012-.497.386-.52.89-.022.503.174.92.439.933.265.011.498-.387.521-.89ZM125.068 75.501c.264-.032.428-.463.367-.963-.061-.5-.324-.88-.587-.848-.263.032-.428.464-.367.964.061.5.324.88.587.847Z"
      />
      <path
        fill="#1C2342"
        d="m117.038 93.213-48.203 8.205c-2.623.278-4.474-1.848-4.697-3.91l-7.874-71.56c-.224-2.063.504-4.684 3.743-5.26l46.378-3.073c2.001-.23 3.493 1.293 3.72 3.355l9.987 67.956c.223 2.062-.981 3.981-3.054 4.29v-.003Z"
      />
      <path
        fill="#1E3D91"
        d="m117.103 92.499-48.067 7.872c-2 .23-3.805-1.257-4.028-3.32l-7.92-72.198c-.224-2.062 1.219-3.922 3.22-4.152l46.901-4.18c2-.23 3.493 1.293 3.72 3.355l9.09 68.51c.224 2.063-.908 3.887-2.908 4.117l-.008-.004Z"
      />
      <path fill="#F4F3F4" d="m117.958 88.2-50.206 8.118-8.006-72.968 49.037-4.426 9.175 69.276Z" />
      <path
        fill="#010101"
        d="m58.865 49.592-2.7-23.985c-.282-2.48 1.484-4.704 3.896-4.914L74.9 19.4 58.865 49.592Z"
        opacity={0.15}
      />
      <path
        fill="#7ACDF1"
        d="M101.161 17.171c-.161-1.852-1.746-3.216-3.543-3.054l-5.986.552c-.269-3.042-2.877-5.283-5.832-5.013-2.95.273-5.132 2.958-4.874 6l-5.986.551c-1.796.167-3.12 1.8-2.958 3.653l.096 4.7 29.183-2.701-.096-4.688h-.004Zm-14.672.409c-1.285.119-2.42-.861-2.535-2.186-.116-1.324.835-2.494 2.12-2.613 1.284-.12 2.42.86 2.535 2.185.115 1.325-.835 2.495-2.12 2.614Z"
      />
      <path
        fill="#51A4DC"
        d="m101.426 22.97-.169-1.107-29.183 2.7.123 1.123c.07.626.612 1.082 1.22 1.03l26.955-2.367c.674-.06 1.154-.694 1.051-1.38h.003Z"
      />
      <path
        stroke="#7ACDF1"
        strokeMiterlimit={10}
        strokeWidth={3}
        d="m64 35.672 42.597-4.898M64.457 39.816l29.268-3.474M64.867 43.818l39.589-4.839M66.102 52.69l29.267-3.479M67.17 61.557l12.791-1.519M66.508 56.687l39.589-4.838M69.04 74.91l13.321-1.935M68.379 70.6l24.878-3.36"
      />
      <path
        stroke="#7ACDF1"
        strokeMiterlimit={10}
        strokeWidth={4.46}
        d="M106.098 84.167c2.524 0 4.57-2.11 4.57-4.712s-2.046-4.711-4.57-4.711c-2.525 0-4.571 2.11-4.571 4.711 0 2.602 2.046 4.712 4.571 4.712Z"
      />
      <path
        fill="#CF8C5F"
        d="M38.096 62.667c-2.292-.531-1.283-6.235 2.362-6.05l17.097 3.027c1.919.41 1.762 2.858-.528 3.07-6.5.6-13.456 1.22-18.93-.047Z"
      />
      <path
        fill="#EDEEEF"
        d="M22.092 44.92c-3.184-4.053 2.494-10.739 7.325-4.106l12.465 17.03c3.02 5.312-2.73 6.685-5.363 3.843L22.092 44.921Z"
      />
      <path
        fill="#CF8C5F"
        d="M56.49 59.486c.377.022 1.47-.381 1.798-.647.99-.802.678-1.008 3.107-1.558.83-.188 1.592-.676 1.747-.206.23.709-.248 1.154-1.113 1.413-.513.155-.977.3-1.096.407-.163.148.42.311.828.256 1.076-.14 2.831-.452 3.77-.86 1.464-.638 1.718.5.722 1.03-1.013.54-1.736.722-2.928.885.037.102.106.162.205.165 1.222.028 2.646-.256 3.847-.688.874-.314 1.46.645.415 1.059-1.275.505-2.621.829-3.882.849l-.035.077c.935.137 1.712.156 2.648.097 1.204-.075 1.117.93-.072 1.15-1.167.215-2.282.134-3.635-.027-.057.097-.032.167.131.2.478.097 1.394.323 2.305.498.739.143.644.973-.13.968-1.092-.007-2.628-.187-4.175-.48-1.827-.346-2.258-1.02-4.445-1.293l-.014-3.297.002.002Z"
      />
      <path fill="#C67B47" d="m53.769 58.975.391 3.997c-.765.066-1.53.127-2.3.183l1.193-4.306.716.126Z" />
      <path
        fill="#EDEEEF"
        d="M40.283 56.378 53.414 58.7l-.278 5.035c-5.355.435-11.462.171-15.183-.996-2.244-.703-1.313-6.546 2.33-6.362Z"
      />
    </svg>
  )
}

export default NoResultIcon
